import { useTranslation } from 'react-i18next';
import React, {useState, Fragment,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Button, TextField, Typography, MenuItem, Box, TableContainer, TableHead, TableBody, Table, TableRow, TableCell, IconButton, Grid, Tooltip} from "@mui/material";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import { useMessage } from '../../context/message-context';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { FullPageSpinner } from "../lib";
import openFile from "../shared/functions/download";
import Page from '../shared/components/PageComponent';
import Layout from '../shared/components/LayoutComponent';
import EditIcon from '@mui/icons-material/Edit';
import InputBox from '../shared/components/InputBox';
import DescriptionIcon from '@mui/icons-material/Description';
function Wertguthaben(props) {
  const { t } = useTranslation();
  const { accessToken,  client} = props;
  const [fileUrl, setFileUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage} = useMessage();
  const [fehler,setFehler] = useState('0');
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [wertguthabenKonten, setWertguthabenKonten] = useState([]);
  const [ausgewaehltesKonto, setAusgewaehltesKonto] = useState('0');
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [subtitle, setSubTitle] = useState(null);
  
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": "WEBWGD",
      "statement": "INIT",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, pruefCb);
    // eslint-disable-next-line
  }, [reload])
  
  const pruefCb = (response) => {
    if (response.status === 200) {
      if (response.data.fehler) {
        setFehler(response.data.fehler)
      }
      if (response.data.subtitle) {
        setSubTitle(response.data.subtitle);
      }
      setWertguthabenKonten(response.data.konto)
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message)
      } else {
        
      }
      navigate(-1);
    }  
  }
  const closeModal = () => {
    setShowModal(false);
  }
    
  const open = () => {
    setShowModal(true);
    if (!fileUrl) {
      downloadFile();
    }
  }
  const downloadFile = () => {
    setFileUrl(null);
    const payload={
        "mandant": client, 
        "program": "WEBWGD",
        "statement": "HOLE_DATEI",
    }
    const headers = {
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
    .then((response) => {
      console.log(response);
      var fileName = 'Wertguthabenstand.pdf';
      var contentFile = response.data;
      openFile(fileName, contentFile);
      closeModal();
    })
    .catch(function (error) {
      console.log(error);
      closeModal();
      showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
    });  
  }
  const WertguthabenAuswahl = wertguthabenKonten.map((konto, count) => {
    return(
      <MenuItem key={konto.LWGVKEY} value={count}>{konto.BEZEICHNUNG}</MenuItem>
    )
  })
  const kontenDetails = wertguthabenKonten[ausgewaehltesKonto]?.details?.neu?.map((detail) => {
    return(
      <TableRow>
        <TableCell>
          {detail.text}
        </TableCell>
        <TableCell align="right">
          {detail.wert}
        </TableCell>
      </TableRow>
    )
  })
  const openEditDialog = () => {
    setEditDialogOpen(true);
  }
  const inputBoxResult = (results) => {
    setIsSending(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": "WEBWGD",
      "statement": "ANTWORTEN",
      "LWGVKEY": wertguthabenKonten[ausgewaehltesKonto]?.LWGVKEY,
      "LFLXKEY": wertguthabenKonten[ausgewaehltesKonto]?.LFLXKEY,
      "DBFELDER": wertguthabenKonten[ausgewaehltesKonto]?.details.DBFELDER,
      "antworten": results
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, resultCb, errorCb);
  }
  const resultCb = (response) => {
    setIsSending(false);
    if (response.status === 200) {
      showSuccessMessage(t("Ihre Änderungen wurden übernommen"));
      setEditDialogOpen(false);
      setReload(!reload);
    } else {
      showErrorMessage(response.data.message);
    }
  }
  const errorCb = () => {
    setIsSending(false);
    showErrorMessage(t("Änderung konnte nicht gesendet werden. Bitte versuchen Sie es erneut."));
  }
  if (isLoading) {
    return <LoadingComponent />;
  }
  if (fehler==="1") {
    return (
      <Fragment>
        <Typography>{t("Sie besitzen keine Wertguthaben. Deshalb kann auch kein Druck erstellt werden")}</Typography>
        <Button color="primary" onClick={()=> navigate(-1)}>{t("Zurück zum Verteiler")}</Button>
      </Fragment>
    )
  }
  return (
    <Page>
      <Layout>
        <Box p={1}>
        <Box p={1}>
        <TextField
          select
          variant="outlined"
          label={t("Einzahlungsart")}
          value={ausgewaehltesKonto}
          onChange={(event) => setAusgewaehltesKonto(event.target.value)}
          fullWidth
        >
        {WertguthabenAuswahl}
        </TextField>
        </Box>
        <Box p={1}>
        {subtitle &&
            subtitle?.split('<br>').map((subtitlepart) => {
              return(<Typography variant='body1' >{subtitlepart}</Typography>);
            })
        }
        </Box>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Tooltip title={t("Einzahlung bearbeiten")}>
            <IconButton color="primary" disabled={wertguthabenKonten[ausgewaehltesKonto]?.details === undefined} onClick={openEditDialog}><EditIcon/></IconButton>
            </Tooltip>
          </Grid>
        <Grid item>
          <Tooltip title={t("Wertguthabenstände anzeigen")}>
            <IconButton color="primary" onClick={open}><DescriptionIcon/></IconButton>
            </Tooltip>
        </Grid>
        </Grid>
        <Box p={1}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography>{t("Bezeichnung")}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography>{t("Wert")}</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {kontenDetails}
            </TableBody>
          </Table>
        </TableContainer>
        </Box>
        </Box>
        {showModal && <FullPageSpinner/>}
      </Layout>
      <InputBox
        open={editDialogOpen}
        handleResponse={inputBoxResult}
        fragen={wertguthabenKonten[ausgewaehltesKonto]?.details?.fragen}
        subtitle={wertguthabenKonten[ausgewaehltesKonto]?.details?.ALLGINFOHTML}
        title={wertguthabenKonten[ausgewaehltesKonto]?.details?.titel}
        onClose={() => setEditDialogOpen(false)}
      />
      {isSending && <FullPageSpinner/>}
    </Page>
  );  
}
export default Wertguthaben;
